import request from '@/utils/request'

export function fetchCommentList(data) {
  return request({
    url: '/v1/video-fe/get-comment',
    method: 'get',
    params: data
  })
}

export function addComment(data) {
  return request({
    url: '/v1/comment-fe/add',
    method: 'post',
    data
  })
}

